import React from "react";
import { useIntl } from 'react-intl';
import classes from './footer.module.scss'

export default function Footer() {
  const { formatMessage } = useIntl();
  const year = 2021
  return(
    <div className="base-template__footer">
      {formatMessage({id: "app_gallery_footer"}, {value: year})}
    </div>
  )
}

export const New_footer = () => {
  const { formatMessage } = useIntl();

  return (
    <div className={(classes.base_template__footer)}>
      © {formatMessage({
          id: 'shared_copyrights_calendar_year',
        })} All rights reserved. Greenway Health, LLC&nbsp;-&nbsp;
      
      <a href="https://developers.greenwayhealth.com/developer-platform/page/terms-of-service"
        target='_blank'
        rel="noreferrer noopener"
      >
        {formatMessage({
          id: 'developer_landing_footer_terms_of_service',
        })}
      </a>&nbsp;-&nbsp;
      <a href="https://developers.greenwayhealth.com/developer-platform/page/privacy-policy" 
        target='_blank'
        rel="noreferrer noopener"
      >
        {formatMessage({
          id: 'developer_landing_footer_privacy_policy',
        })}
      </a>
    </div>

  )
}